import { gql } from "@apollo/client";

export const GET_INSUMOS = gql`
    query allInsumosRI($where: t_InsumoFilterInput, $idDatosGenerales: Int!) {
        allInsumosRI(
            where: $where,
            idDatosGenerales: $idDatosGenerales
        ) {
            descripcion
            idInsumoN
            idUnidad
            presentacion
            presentacionGenerica
            idUnidadNavigation{
                alias
            }
        }
    }
`;